// import interfaceUrl from '../../interfaceUrl';
import { axiosRequest } from '../../utils/commonFn';
import {loadshopcarttotalcountUrl} from '../../consts';

/**
 * @param {object} params 参数
 * @returns 
 */
const getShopCarTotalCount = async (params) => {
    const { data } = await axiosRequest(loadshopcarttotalcountUrl, 'get', params, {})
    return data
}


export {
    getShopCarTotalCount
}